import { Component, DestroyRef, inject, OnInit, input } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'dish-mat-menu-button',
    templateUrl: './mat-menu-button.component.html',
    styleUrls: ['./mat-menu-button.component.scss'],
    imports: [MatButton, MatIcon]
})
export class MatMenuButtonComponent implements OnInit {
  readonly menuClosed = input<Observable<string>>(undefined);
  readonly menuName = input<string>(undefined);
  private destroyRef = inject(DestroyRef);

  clicked = false;

  ngOnInit() {
    this.menuClosed()
      .pipe(
        tap((menuName) => {
          if (this.menuName() === menuName) this.clicked = false;
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  toggleClicked() {
    this.clicked = !this.clicked;
  }
}
